module.exports = __webpack_public_path__ + "static/img/14000152.512b14e5.png";